exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fixed-bottom .fixed-bottom__content[data-v-0d84e666] {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  z-index: 3;\n}\n.fixed-bottom .fixed-bottom__placeholder[data-v-0d84e666] {\n  visibility: hidden;\n}", ""]);

// exports
